import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class SettingsService {
  
  selectedAction:any;

  constructor() {}
}
